import setOnlyScoped from './set-only-scoped';
import setOnlyGlobal from './set-only-global';
import setScopedGuestlists from './set-scoped-guestlists';

export default {
    setOnlyScoped,
    setOnlyGlobal,
    setScopedGuestlists
}



// WEBPACK FOOTER //
// ./src/app/store/templates/main/mutations/index.js